import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { isMobile } from "react-device-detect";

import { StyleThemeContext } from "../../../contexts/style-theme.context";
import { CommunityContext } from "../../../contexts/community.context";
import { RecentCoinFlipsProvider } from "../../../contexts/recent-coin-flips.context";
import { TopCoinFlipsProvider } from "../../../contexts/top-coin-flips.context";
import { SideBetsProvider } from "../../../contexts/side-bets.context";
import { ToolBar } from "../../components";
import MenuBar from "../../components/menu-bar";
// import InfoBar from "../../components/info-bar";
import LiveDataBar from "../../components/live-data-bar";
import { SettingProvider } from "../../../contexts/setting.context";
import { Sidebar } from "../../components/side-bar";
import { SidebarContext } from "../../../contexts/sidebar-context";

const getBgImageUrl = (bgImageUrl: string, style: string, community: any) => {
    switch (style) {
        case 'light':
            return bgImageUrl;
        case 'dark':
            return community?.backgroundImageDark ?? bgImageUrl
        case 'dark-black':
            return community?.backgroundImageWhale ?? bgImageUrl
    }
}
const getMobileBgImageUrl = (bgImageUrl: string, style: string, community: any) => {
    switch (style) {
        case 'light':
            return bgImageUrl;
        case 'dark':
            return community?.backgroundImageMobileDark ?? bgImageUrl
        case 'dark-black':
            return (community?.backgroundImageMobileWhale ?? community?.backgroundImageMobileDark) ?? bgImageUrl
    }
}

const ClassicLayout = () => {
    const { style } = useContext(StyleThemeContext);
    const { community } = useContext(CommunityContext);
    const { isExpanded } = useContext(SidebarContext);

    const bgImageUrl = isMobile ? community?.backgroundImageMobile ?? community?.backgroundImage : community?.backgroundImage;
    const bgUrl = isMobile ? getMobileBgImageUrl(bgImageUrl, style, community) : getBgImageUrl(bgImageUrl, style, community);
    return (
        <div className={style}>
            <div
                className={
                    "sm:h-full" +
                    (bgUrl?.length ? " bg-image" : "") +
                    (community?.slug === "xmas" ? " snow-bg" : "")
                }
                style={{
                    backgroundImage: `url(${bgUrl}`
                }}>
                <RecentCoinFlipsProvider>
                    <TopCoinFlipsProvider>
                        <SettingProvider>
                            <SideBetsProvider>
                                <Sidebar></Sidebar>
                                <div className={`transition-all  ${isExpanded
                                        ? 'lg:ml-[250px]' // Expanded sidebar width
                                        : 'lg:ml-[80px]'  // Collapsed sidebar width
                                    } ml-0`} // No margin on mobile
                                >
                                    <LiveDataBar />
                                    <MenuBar></MenuBar>
                                    <Outlet></Outlet>
                                    <ToolBar></ToolBar>
                                    {/* <InfoBar social={community}></InfoBar> */}
                                    {/* <SocialBar /> */}
                                </div>
                            </SideBetsProvider>
                        </SettingProvider>
                    </TopCoinFlipsProvider>
                </RecentCoinFlipsProvider>
            </div>
        </div>
    );
};
export default ClassicLayout;
